module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kc-Ld.619599d5.png";